import React from 'react';
import MediaQuery from 'react-responsive'
import Carousel from './Carousel.js';
import CarouselT from './Carousel-t.js';
import './Home3-2.scss'

const HomeDesktop = () => {
    
    const titleFirst = "Karta";
    const titleSecond = "Visa Infinite";
    const subtitleFirst = "Use it anywhere in the world.";
    const subtitleSecond = "No international transaction fees";

    return (
        <>
            <MediaQuery minWidth={1050}>
                <div className="third-body-section-2 disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-row justify-center align-start">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-center align-center ">
                                <p className = "title-1-first">{titleFirst}<br/></p>
                                <p className = "title-1-second"><b>{titleSecond}</b></p>
                                <p className = "text-1-first">{subtitleFirst}</p>
                                <p className = "text-1"><b>{subtitleSecond}</b></p>
                            </div>
                        </div>
                        <div className = "fade-slide-in-animation carousel-row">
                            <Carousel />
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1049.99} minWidth={900}>
                <div className="third-body-section-2-m disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-column justify-center align-center">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-center align-center">
                                <p className = "title-1-first">{titleFirst}<br/></p>
                                <p className = "title-1-second"><b>{titleSecond}</b></p>
                                <p className = "text-1-first">{subtitleFirst}</p>
                                <p className = "text-1"><b>{subtitleSecond}</b></p>
                            </div>
                        </div>
                        <div className = "fade-slide-in-animation carousel-row">
                            <Carousel />
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth = {899.99}>
                <div className="third-body-section-2-t disposition-row justify-center align-center" id = "section-3">
                    <div className="third-body-elements disposition-column justify-start align-center">
                        <div className="first-row disposition-column justify-center align-center">
                            <div className = "description-section fade-slide-in-animation disposition-column justify-center align-center">
                                <p className = "title-1-first">{titleFirst}<br/></p>
                                <p className = "title-1-second"><b>{titleSecond}</b></p>
                                <p className = "text-1-first">{subtitleFirst}</p>
                                <p className = "text-1"><b>{subtitleSecond}</b></p>
                            </div>
                        </div>
                        <div className = "fade-slide-in-animation carousel-row">
                            <CarouselT />
                        </div>
                    </div>
                </div>
            </MediaQuery>
        </>
    );
};

export default HomeDesktop;
